module.exports = __webpack_public_path__ + "static/media/ceiling_traingular.d5a4e91a.jpg";